import loadable from "@loadable/component";
import FullPageLoader from "@Components/FullPageLoader";
import { ErrorBoundary } from "../../components";

const Nearby = loadable(() => import("./Nearby"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <Nearby {...props} />
  </ErrorBoundary>
);
